import { publicCase } from '../utils/string';

export const auditLogColumns = [
  {
    label: 'Requested Url',
    value: 'requestedUrl',
    mobile: true,
  },
  {
    label: 'Type',
    value: 'type',
  },
  {
    label: 'Role',
    value: 'role',
  },
  {
    label: 'Time',
    value: 'time',
  },
  {
    label: 'Source Ip',
    value: 'sourceId',
  },
  {
    label: 'Processing Time (sec)',
    value: 'durationInMillis',
  },
  {
    label: 'Status',
    value: 'status',
  },
];

export const AuditLogType = {
  ACCESS_ADJUSTMENT: 'ACCESS_ADJUSTMENT',
  ACCESS_REQUESTS: 'ACCESS_REQUESTS',
  ANALYTIC_DATA_MODIFICATION: 'ANALYTIC_DATA_MODIFICATION',
  ANALYTIC_EVENT: 'ANALYTIC_EVENT',
  API_CLIENTS: 'API_CLIENTS',
  AUTH_EVENT: 'AUTH_EVENT',
  DEVICES_ADJUSTMENT: 'DEVICES_ADJUSTMENT',
  DEVICES_REQUESTS: 'DEVICES_REQUESTS',
  MATERIALS: 'MATERIALS',
  REPORTS: 'REPORTS',
  RESTAURANT_ADJUSTMENT: 'RESTAURANT_ADJUSTMENT',
  RESTAURANT_REQUESTS: 'RESTAURANT_REQUESTS',
  SETTING_ADJUSTMENT: 'SETTING_ADJUSTMENT',
  SETTING_REQUESTS: 'SETTING_REQUESTS',
  STREAMS: 'STREAMS',
  SUPPORT: 'SUPPORT',
  SYSTEM_EVENT: 'SYSTEM_EVENT',
  UNDEFINED: 'UNDEFINED',
  USERS: 'USERS',
};

export const auditLogTypes = Object.values(AuditLogType);

export const auditLogTypeOptions = auditLogTypes.map(type => ({
  label: publicCase(type),
  value: type,
}));

export const auditLogTypeColors = {
  [AuditLogType.ACCESS_ADJUSTMENT]: { text: '#2173D2', bg: '#2173D21A' },
  [AuditLogType.ACCESS_REQUESTS]: { text: '#E88641', bg: '#E886411A' },
  [AuditLogType.ANALYTIC_DATA_MODIFICATION]: { text: '#B24BB7', bg: '#D872DD1A' },
  [AuditLogType.ANALYTIC_EVENT]: { text: '#00B09B', bg: '#00B09B1A' },
  [AuditLogType.API_CLIENTS]: { text: '#4F46E5', bg: '#4F46E51A' },
  [AuditLogType.AUTH_EVENT]: { text: '#17B61F', bg: '#17B61F1A' },
  [AuditLogType.DEVICES_ADJUSTMENT]: { text: '#3E912D', bg: '#3E912D1A' },
  [AuditLogType.DEVICES_REQUESTS]: { text: '#62A331', bg: '#62A3311A' },
  [AuditLogType.MATERIALS]: { text: '#7A43B6', bg: '#7A43B61A' },
  [AuditLogType.REPORTS]: { text: '#E24C72', bg: '#E24C721A' },
  [AuditLogType.RESTAURANT_ADJUSTMENT]: { text: '#FF9900', bg: '#FF99001A' },
  [AuditLogType.RESTAURANT_REQUESTS]: { text: '#8BC34A', bg: '#8BC34A1A' },
  [AuditLogType.SETTING_ADJUSTMENT]: { text: '#546E7A', bg: '#546E7A1A' },
  [AuditLogType.SETTING_REQUESTS]: { text: '#90A4AE', bg: '#90A4AE1A' },
  [AuditLogType.STREAMS]: { text: '#CB444A', bg: '#CB444A1A' },
  [AuditLogType.SUPPORT]: { text: '#03A9F4', bg: '#03A9F41A' },
  [AuditLogType.SYSTEM_EVENT]: { text: '#000000', bg: '#0000001A' },
  [AuditLogType.UNDEFINED]: { text: '#AAAAAA', bg: '#AAAAAA1A' },
  [AuditLogType.USERS]: { text: '#E91E63', bg: '#E91E631A' },
};

export const auditLogRoles = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Admin',
    value: 'ADMIN',
  },
  {
    label: 'User',
    value: 'USER',
  },
  {
    label: 'Device',
    value: 'DEVICE',
  },
  {
    label: 'Manager',
    value: 'MANAGER',
  },
  {
    label: 'Tablet',
    value: 'TABLET',
  },
  {
    label: 'API Client',
    value: 'API_CLIENT',
  },
];

export const auditLogStatusColors = {
  success: '#17B61F',
  error: '#DD0031',
};
